<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";

    export let icon = "assets/wallpaper_icon.png";
    export let selected = false;
    let clazz = "";
    export {clazz as class}
    const dispatch = createEventDispatcher();
    let mainDiv: HTMLDivElement;

    onMount(()=>{
        if(selected)
            mainDiv.click()
    })
</script>

<div bind:this={mainDiv} class="transition p-1 duration-150 {selected ? 'bg-white ring-1' : 'bg-gray-200'} hover:bg-white bg-opacity-40 rounded-md flex items-center {clazz}" on:click>
    {#if (icon && icon.trim().length)}
        <!--{#if (icon.endsWith("svg"))}-->
        <!--    {icon}-->
        <!--{:else }-->
        <img src="{icon}" class="w-full inline-block align-middle object-contain my-auto">
        <!--{/if}-->
    {/if}
</div>

<style lang="postcss">
</style>
